import React, { useMemo } from "react";

const COLORS = ["#E11D48", "#0052FF", "#F59E0B", "#10B981", "#A855F7", "#F97316", "#FACC15"];

export function Confetti({ count = 90 }) {
  const pieces = useMemo(() => Array.from({ length: count }, (_, i) => ({
    left: Math.random() * 100,
    size: 6 + Math.random() * 8,
    color: COLORS[i % COLORS.length],
    dur: 3 + Math.random() * 3,
    delay: -Math.random() * 6,
    drift: (Math.random() - 0.5) * 160,
    round: Math.random() > 0.6,
  })), [count]);
  return (
    <div className="pointer-events-none fixed inset-0 z-40 overflow-hidden" data-testid="totem-confetti">
      <style>{`
        @keyframes totem-confetti-fall {
          0% { transform: translate3d(0, -10vh, 0) rotate(0deg); }
          100% { transform: translate3d(var(--drift), 110vh, 0) rotate(720deg); }
        }
        @keyframes totem-banner-pop { 0% { transform: scale(0.3) rotate(-6deg); opacity: 0; } 70% { transform: scale(1.08) rotate(2deg); opacity: 1; } 100% { transform: scale(1) rotate(0); opacity: 1; } }
        @keyframes totem-banner-pulse { 0%,100% { transform: scale(1); } 50% { transform: scale(1.05); } }
      `}</style>
      {pieces.map((p, i) => (
        <span
          key={i}
          className="absolute top-0 block"
          style={{
            left: `${p.left}%`, width: p.size, height: p.round ? p.size : p.size * 0.45,
            background: p.color, borderRadius: p.round ? "50%" : "2px", "--drift": `${p.drift}px`,
            animation: `totem-confetti-fall ${p.dur}s linear ${p.delay}s infinite`,
          }}
        />
      ))}
    </div>
  );
}

export function GoalBanner() {
  return (
    <div className="pointer-events-none fixed inset-x-0 top-[18vh] z-50 flex justify-center px-4" data-testid="totem-goal-banner">
      <div style={{ animation: "totem-banner-pop 0.8s cubic-bezier(.2,1.4,.4,1) both" }}>
        <div
          className="rounded-2xl border-4 border-white bg-gradient-to-r from-emerald-500 via-emerald-600 to-teal-600 px-8 py-4 text-center text-4xl font-black uppercase tracking-tight text-white shadow-2xl sm:text-6xl md:text-7xl"
          style={{ animation: "totem-banner-pulse 0.95s ease-in-out 0.8s infinite", textShadow: "0 4px 0 rgba(0,0,0,0.2)" }}
        >
          Obiettivo raggiunto!
        </div>
      </div>
    </div>
  );
}
